// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary: black;
  --body: rgb(216, 212, 212);
  --questionBody: #ebeaea;
  --text: black;
}

body {
  color: var(--text) !important;
  /* background-color: var(--body); */
}

textarea {
  resize: vertical;
  width: 100%;
  border: 1px solid black;
}

.questionCard {
  width: 40%;
  box-sizing: border-box;
  height: calc(100vh - 10vh);
  background-color: white;
  border-radius: 20px;
  overflow-y: auto;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px,
    rgba(0, 0, 0, 0.1) 0px 2px 4px 0px,
    rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;
}

.questionCard::-webkit-scrollbar {
  display: none;
}

/* change here */

/* .button {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  text-align: center;
  padding: 10px 20px 10px 20px;
  background-color: rgb(233, 29, 37);
  color: white;
  outline: none;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 700;
  font-size: 12px;
}

.button:active {
  background-color: rgb(218, 96, 100);
  transform: translate(2px, 2px);
}

.button:disabled {
  background-color: rgba(216, 125, 128, 0.856);
} */

.question-text {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 10px;
}

.question-body {
  display: flex;
  flex-direction: column;
  height: calc(100% - 50px);
  width: 100%;
  padding: 30px;
  padding-bottom: 0px;
  gap: 20px;
  overflow-y: auto;
  background-color: var(--questionBody) !important;
}

::-webkit-scrollbar {
  width: 5px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

@media screen and (max-width: 1500px) {
  .button {
    font-size: 10px;
  }
}

@media screen and (max-width: 1100px) {
  .button {
    padding: 10px 10px 10px 10px;
  }
}

@media screen and (max-width: 1000px) {
  .button {
    padding: 10px 20px 10px 20px;
  }
}

@media screen and (max-width: 700px) {
  .question-text {
    font-size: 16px;
    font-weight: 500;
  }
}

@media screen and (max-width: 1000px) {
  textarea {
    width: 100%;
    box-sizing: border-box;
  }
}

@media screen and (max-width: 600px) {
  textarea {
    max-height: auto;
  }
}

@media screen and (max-width: 900px) {
  .questionCard {
    width: 60%;
  }
}

@media screen and (max-width: 700px) {
  .questionCard {
    width: 100%;
  }
  .question-body {
    height: 92%;
  }
}

.MuiButton-root {
  border-radius: 8px !important;
  padding-inline: 20px !important;
  font-weight: 500 !important;
  word-spacing: 2px !important;
  box-shadow: none !important;
  text-transform: capitalize !important;
}
/* change here */
/* .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: rgb(233, 29, 37) !important;
} */
`, "",{"version":3,"sources":["webpack://./src/components/question.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB;;mDAEiD;AACnD;;AAEA;EACE,aAAa;AACf;;AAEA,gBAAgB;;AAEhB;;;;;;;;;;;;;;;;;;;;;;;;GAwBG;;AAEH;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,UAAU;AACZ;AACA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;IACX,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;EACb;EAIA;IACE,WAAW;EACb;AALF;;AAQA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;EAC3B,qCAAqC;AACvC;AACA,gBAAgB;AAChB;;GAEG","sourcesContent":[":root {\r\n  --primary: black;\r\n  --body: rgb(216, 212, 212);\r\n  --questionBody: #ebeaea;\r\n  --text: black;\r\n}\r\n\r\nbody {\r\n  color: var(--text) !important;\r\n  /* background-color: var(--body); */\r\n}\r\n\r\ntextarea {\r\n  resize: vertical;\r\n  width: 100%;\r\n  border: 1px solid black;\r\n}\r\n\r\n.questionCard {\r\n  width: 40%;\r\n  box-sizing: border-box;\r\n  height: calc(100vh - 10vh);\r\n  background-color: white;\r\n  border-radius: 20px;\r\n  overflow-y: auto;\r\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px,\r\n    rgba(0, 0, 0, 0.1) 0px 2px 4px 0px,\r\n    rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;\r\n}\r\n\r\n.questionCard::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n/* change here */\r\n\r\n/* .button {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  text-align: center;\r\n  padding: 10px 20px 10px 20px;\r\n  background-color: rgb(233, 29, 37);\r\n  color: white;\r\n  outline: none;\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  font-weight: 700;\r\n  font-size: 12px;\r\n}\r\n\r\n.button:active {\r\n  background-color: rgb(218, 96, 100);\r\n  transform: translate(2px, 2px);\r\n}\r\n\r\n.button:disabled {\r\n  background-color: rgba(216, 125, 128, 0.856);\r\n} */\r\n\r\n.question-text {\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.question-body {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: calc(100% - 50px);\r\n  width: 100%;\r\n  padding: 30px;\r\n  padding-bottom: 0px;\r\n  gap: 20px;\r\n  overflow-y: auto;\r\n  background-color: var(--questionBody) !important;\r\n}\r\n\r\n::-webkit-scrollbar {\r\n  width: 5px;\r\n}\r\n/* Track */\r\n::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n}\r\n\r\n/* Handle */\r\n::-webkit-scrollbar-thumb {\r\n  background: #888;\r\n}\r\n\r\n/* Handle on hover */\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: #555;\r\n}\r\n\r\n@media screen and (max-width: 1500px) {\r\n  .button {\r\n    font-size: 10px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1100px) {\r\n  .button {\r\n    padding: 10px 10px 10px 10px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1000px) {\r\n  .button {\r\n    padding: 10px 20px 10px 20px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 700px) {\r\n  .question-text {\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1000px) {\r\n  textarea {\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 600px) {\r\n  textarea {\r\n    max-height: auto;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 900px) {\r\n  .questionCard {\r\n    width: 60%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 700px) {\r\n  .questionCard {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 700px) {\r\n  .question-body {\r\n    height: 92%;\r\n  }\r\n}\r\n\r\n.MuiButton-root {\r\n  border-radius: 8px !important;\r\n  padding-inline: 20px !important;\r\n  font-weight: 500 !important;\r\n  word-spacing: 2px !important;\r\n  box-shadow: none !important;\r\n  text-transform: capitalize !important;\r\n}\r\n/* change here */\r\n/* .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\r\n  border-color: rgb(233, 29, 37) !important;\r\n} */\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
